var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"20rem"},attrs:{"title":_vm.message,"tag":"article"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }